export const environment = {
  production: false,
  urlApi: 'https://97179kzo30.execute-api.us-east-1.amazonaws.com/dev/api/v1',
  urlPDFApi: 'https://z7vn0jdawj.execute-api.us-east-1.amazonaws.com/dev/api/v1'
};
